<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 48 48">
    <path fill="#90CAF9" d="M33 42L5 42 5 4 24 4 33 13z" />
    <path fill="#E1F5FE" d="M31.5 14L23 14 23 5.5z" />
    <path
      fill="#616161"
      d="M38.3 34.8H41.099999999999994V46.8H38.3z"
      transform="rotate(-45.001 39.762 40.763)"
    />
    <path fill="#616161" d="M28 18A11 11 0 1 0 28 40A11 11 0 1 0 28 18Z" />
    <path fill="#90CAF9" d="M28 20A9 9 0 1 0 28 38A9 9 0 1 0 28 20Z" />
    <path
      fill="#37474F"
      d="M39.5 37.6H42.3V46.3H39.5z"
      transform="rotate(-45.001 40.93 41.93)"
    />
    <g>
      <path
        fill="#1976D2"
        d="M30 31h-9.7c.4 1.6 1.3 3 2.5 4H30V31zM20.3 27H30v-4h-7.3C21.5 24 20.7 25.4 20.3 27zM20.1 20H11v2h7.3C18.8 21.3 19.4 20.6 20.1 20zM17.1 24H11v2h5.4C16.6 25.3 16.8 24.6 17.1 24zM16 29c0-.3 0-.7.1-1H11v2h5.1C16 29.7 16 29.3 16 29zM16.4 32H11v2h6.1C16.8 33.4 16.6 32.7 16.4 32z"
      />
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "AnalyzeIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
